function getHistoryState(type) {
    return !(type.includes('light') || type.includes('switch'));
}

export default getHistoryState;